import React from 'react';
import PropTypes from 'prop-types';
import css from './NoResultsFoundMessage.module.scss';

const NoResultsFoundMessage = ({message = 'No results found...'}) => {
  return (
    <div className={css.noResultsFoundSection}>
      <div className={css.emoji}>🔍</div>
      <h4>{message}</h4>
     </div>
  );
};

NoResultsFoundMessage.propTypes = {
  message: PropTypes.string,
};

export default NoResultsFoundMessage;
